export const classes: ISelectors = {
  active: 'filters-item__link--active',
  activeHeader: 'filters-wrapper--active',
  // disabled: 'filters-more--disabled',
  filtersAuto: 'filters-wrapper--auto',
  fixedHeader: 'headerMain--fixed',
  jsMenuMore: 'js-menu-more',
  jsMenuMoreHidden: 'filters-item--hide',
  overflowHidden: 'filters-wrapper--overflow',
}

export const HEIGTH_HALF: number = 52 // px

export const selectors: ISelectors = {
  base: '[data-selector="header"]',
  filtersItem: '[data-selector="filtersItem"]',
  filtersWrapper: '[data-selector="filtersWrapper"]',
  listCategories: '[data-selector="listCategories"]',
  menu: '[data-selector="headerMenuFilters"]',
  more: '[data-selector="categoriesMore"]',
}

export const SPACE_FROM_TOP: number = 230 // px
